import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { branch, compose, renderComponent, renderNothing, withProps } from 'recompose';
import { routes, tabKeys } from '../../../../../constants';
import { fullName, isExternalUser } from '../../../../../services';
import { Icon } from '../../../../components';
import Loading from '../../../loading';

const Detail = branch(
  ({ detail }) => !detail,
  renderNothing
)(({ detail, label }) => (
  <p>
    <label>{label}</label>
    {detail}
  </p>
));

const PersonalDetails = ({
  businesses,
  name,
  user: {
    email,
    phone,
    postcode,
    state,
    suburb
  },
  enableUpdate,
  isFullWidth,
  isExternalUser
}) => (
    <div className={isFullWidth ? 'profile--personal-details-full-width' : 'profile--personal-details'}>
      <div className='inner'>
        <h2>
          <Icon icon='user' /> Personal details
        </h2>
        <div className='title'>
          {name}
          {
            fp.map((businessName) =>
              [
                <br key={`${businessName}-break`} />,
                <small key={businessName}>
                  {he.decode(businessName)}
                </small>
              ]
            )(businesses)
          }
        </div>
        {
          fp.flow(
            fp.toPairs,
            fp.map(([key, value]) =>
              <Detail
                key={key}
                label={fp.flow(fp.lowerCase, fp.upperFirst)(key)}
                detail={value} />
            )
          )({
            email: email,
            contactNumber: phone,
            address: fp.flow(
              fp.join(' '),
              fp.trim,
            )([suburb, state, postcode])
          })
        }
        {
          (enableUpdate && !isExternalUser) ? <div className='main-button'>
            <LinkContainer to={routes.app.accountSettings(tabKeys.accountSettings.personalDetail)}>
              <Button>
                Update details
            </Button>
            </LinkContainer>
          </div> : null
        }
      </div>
    </div>
  );

export default compose(
  branch(
    ({ user: { id: userId } }) => !userId,
    renderComponent(Loading)
  ),
  withProps(({ user }) => ({
    name: fullName(user),
    isExternalUser: isExternalUser(user)
  }))
)(PersonalDetails);



// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/partials/personal-details.js